module.exports = __webpack_public_path__ + "img/default-skin.b989c989.svg";